import { Link as MuiLink, LinkProps as MuiLinkProps } from '@mui/material'
import { forwardRef } from 'react'
import { LinkProps, NavLinkProps } from 'react-router-dom'

import { NavRouteLink, RouteLink } from './route-link'

export const Link = forwardRef<
  HTMLElement,
  LinkProps & Omit<MuiLinkProps, 'href'>
>((props, ref) => {
  return (
    <MuiLink
      ref={ref}
      component={RouteLink}
      typography="caption2"
      underline="hover"
      color="primary"
      {...props}
    />
  )
})

export const NavLink = forwardRef<
  HTMLElement,
  NavLinkProps & Omit<MuiLinkProps, 'href'>
>((props, ref) => {
  return (
    <MuiLink
      ref={ref}
      component={NavRouteLink}
      typography="caption2"
      underline="hover"
      color="primary"
      {...props}
    />
  )
})
